import { DOCUMENT } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { ModalController, PopoverController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { BreadcrumbService } from "../breadcrumb/breadcrumb.service";
import { SideMenuService } from "../side-menu/side-menu.service";
import { ViewPdfModalPage } from "../view-pdf-modal/view-pdf-modal.page";
import { Router } from "@angular/router";
import { ROUTES } from "src/app/utils/routes";
import { Capacitor } from "@capacitor/core";

@Component({
  selector: "page-header",
  templateUrl: "./page-header.component.html",
  styleUrls: ["./page-header.component.scss"],
})
export class PageHeaderComponent {
  isMobile: boolean = false;
  ROUTES = ROUTES;
  elem: any;
  fullScreen: boolean = false;
  canShowPrintAndEmail: any;
  _subscription: Subscription;
  canShowManageHelp: boolean;
  canShowRefresh: boolean;
  canShowRefreshGraph: boolean;
  canShowChartSettingIcon: boolean;
  canShowViewToggle: boolean;
  viewToggleIcon: string = "grid-outline";
  viewToggleTitle: string = "Card View";

  constructor(
    @Inject(DOCUMENT) private document: any,
    public popoverController: PopoverController,
    private modalController: ModalController,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    public sideMenuService: SideMenuService
  ) {}

  async ngOnInit() {
    this.isMobile =
      Capacitor.getPlatform() === "ios" ||
      Capacitor.getPlatform() === "android";
    this._subscription = this.breadcrumbService.showRefresh.subscribe((res) => {
      this.canShowRefresh = res;
    });
    this._subscription.add(
      this.breadcrumbService.showEmailAndPrint.subscribe((res) => {
        this.canShowPrintAndEmail = res;
      })
    );
    this._subscription.add(
      this.breadcrumbService.showGraphFilterButton.subscribe((res) => {
        this.canShowRefreshGraph = res;
      })
    );
    this._subscription.add(
      this.breadcrumbService.showChartViewSettingButton.subscribe((res) => {
        this.canShowChartSettingIcon = res;
      })
    );
    this._subscription.add(
      this.breadcrumbService.showViewToggleButton.subscribe((res) => {
        this.canShowViewToggle = res;
      })
    );
    this._subscription.add(
      this.breadcrumbService.viewToggleIcon.subscribe((res) => {
        this.viewToggleIcon = res;
      })
    );
    this._subscription.add(
      this.breadcrumbService.viewToggleTitle.subscribe((res) => {
        this.viewToggleTitle = res;
      })
    );
    this._subscription.add(
      this.breadcrumbService.showManageHelpButton.subscribe((res) => {
        this.canShowManageHelp = res;
      })
    );
    this.elem = document.documentElement;
  }

  refreshClicked() {
    this.breadcrumbService.triggerRefreshButtonClick();
  }

  viewToggleClicked() {
    this.breadcrumbService.triggerViewToggleButtonClick();
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  async openPrint() {
    const modal = await this.modalController.create({
      component: ViewPdfModalPage,
      componentProps: {
        id: this.canShowPrintAndEmail,
      },
      cssClass: "full-height full-width",
      showBackdrop: true,
      backdropDismiss: false,
    });
    await modal.present();
  }

  openFullscreen() {
    this.fullScreen = true;
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    this.fullScreen = false;
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }

  async openFilterGraphModal() {
    this.breadcrumbService.triggerGraphFilterButtonClick();
  }

  async openChartViewSettingModal() {
    this.breadcrumbService.triggerChartViewSettingButtonClick();
  }

  async openManageHelp() {
    this.router.navigateByUrl(ROUTES.MANAGE_HELP_PAGE);
  }
}
